<template>
  <page content-class="admin-campaign-list">
    <campaign-editor :campaign="campaign" step="content">
      <!-- Main Content Block -->
      <b-row class="my-3">
        <b-col cols="12" sm="12">
          <div class="d-flex justify-content-between text-right pb-2 px-3" align-h="between">
            <!-- Right Buttons Modal -->
            <div class="d-flex justify-content-between">
              <p><b>{{ totalContentSelected }}</b> {{ $t('campaign-admin.labels.selected-content') }}</p>
            </div>

            <!-- Right Buttons Block -->
            <div>
              <!-- Add New Content Button -->
              <b-btn v-if="isRecruiter" @click.prevent="() => selectedContentShareID = 'NEW'" variant="outline-primary">
                <font-awesome-icon icon="plus"/>
                <span class="d-none d-sm-inline-block">{{ $t('content-fetch.titles.create-content') }}</span>
              </b-btn>
              <entry-where-some-input
                v-if="!$apollo.loading"
                type="contentshares"
                :title="$t('campaign-admin.titles.content')"
                many
                placeholder="Select Content to include this campaign"
                :button-view="true"
                :where="{ status: 'ACTIVE' }"
                order="CREATED_DESC"
                v-model="selectedContentShares"
                :buttonText="$t('campaign-admin.buttons.select-existing-content')"
                buttonIcon="sync"
              />
            </div>
          </div>
          <!-- No Content Selected Statement -->
          <h4 class="my-4 py-4 text-center" v-if="totalContentSelected < 1">
            <strong>{{ $t('campaign-admin.labels.no-content-selected') }}</strong>
          </h4>

          <!-- Draggable Selected Content List-->
          <h4 class="my-4 py-4 text-center" v-if="totalContentSelected > 1 && (filterSelectedContent === null || filterSelectedContent.length === 0)">
            <strong>{{ $t('campaign-admin.labels.no-content-found') }}</strong>
          </h4>
          <b-row>
            <b-col class="draggable draggable-container">
              <draggable
                v-model="selectedContentShares"
                handle=".bars-handle"
                class="mb-4"
              >
                <transition-group>
                  <div
                    class="d-flex justify-content-between mb-2 mx-4 border border-gray-600 rounded bg-white"
                    size="lg"
                    v-for="content in filterSelectedContent"
                    :key="content.id"
                  >
                    <!-- Content Image & Title -->
                    <div class="my-3">
                      <!-- Content Preview Image -->
                      <b-img
                        class="preview-image ml-3"
                        :src="content.imageURL"
                        :alt="content.title"
                        rounded
                      />
                      <!-- Content Title -->
                      <!-- <span class="py-2 pl-1" v-b-modal="`content-view-${content.id}`">
                        {{ content.title }}
                      </span> -->
                      <span class="py-2 pl-2" v-b-modal="`content-view-${content.id}`">
                        {{ truncateContentTitle(content.title) }}
                      </span>
                    </div>
                    <div class="d-flex my-2">
                      <!-- Bookmark Icon -->
                      <!-- <span class="mr-2 bookmark-icon">
                        <font-awesome-icon
                          class="draggable-icon"
                          :class="{ active: referralJamsContent.includes(content.id), inactive: !referralJamsContent.includes(content.id) }"
                          icon="bookmark"
                          @click="bookmarkContent(content.id)"
                        />
                      </span> -->
                      <!-- Bars Icon -->
                      <span class="bars-handle mt-2">
                        <font-awesome-icon
                          class="draggable-icon mr-3 hamburger-icon"
                          icon="bars"
                        />
                      </span>

                      <!-- Content Preview Modal -->
                      <b-modal :id="`content-view-${content.id}`" size="lg" title="Preview" hide-footer lazy>
                        <h2 class="mb-4 mt-2">{{ content.title }}</h2>
                        <rich-text-content class="mb-4" :value="content.description"/>
                      </b-modal>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </b-col>
            <!-- Save & Next Buttons Block -->
            <b-col class="d-flex justify-content-end" cols="12">
              <b-btn variant="transparent" class="ml-3" @click="$router.push({ name: 'EditCampaignJobs', params: { campaignID: campaign.id } })">{{ $t('campaign.scheduled-posts.back') }}</b-btn>
              <div class="flex-fill"></div>
              <b-button class="mr-2" variant="outline-primary" @click="saveContent">
                {{ $t('campaign-admin.buttons.save-content') }}
              </b-button>
              <b-button class="mr-4" variant="primary" @click="saveAndNext()">
                {{ $t('campaign-admin.buttons.save-and-next') }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Error -->
      <error-block v-if="allContentSharesErr" class="mb-3" :err="allContentSharesErr"/>

      <!-- Content -->
      <!-- <template v-if="contentShareConnections && Array.isArray(contentShareConnections.edges) && contentShareConnections.edges.length">
        <b-row class="card-deck p-4">
          <b-col class="mb-3" cols="12" sm="6" lg="4" xl="4" v-for="({ entry }, i) in contentShareConnections.edges" :key="`item-${entry.id}-${i}`">
            <content-card :entry="entry" @trackShare="data => trackShareEvent(entry, data)">
              <template v-slot:footer v-if="isRecruiter && isEnglishLang">
                <b-card-footer class="d-flex align-items-center">
                  <b-btn @click.prevent="() => selectedContentShareID = entry.id" variant="link">{{ $t('contentShares.card.edit-cta') }}</b-btn>
                  <div class="flex-fill"/>
                  <i18n path="general.added" tag="span">
                    <template v-slot:timeAgo>{{ timeAgo(entry.created) }}</template>
                  </i18n>
                </b-card-footer>
              </template>
            </content-card>
          </b-col>
        </b-row> -->

        <!-- Pagination -->
        <!-- <b-card class="bg-transparent border-0" body-class="d-flex flex-row p-3 justify-content-center align-items-center" v-if="contentShareConnections && page && totalPages">
          <b-pagination v-model="filterContentSharesPage" :per-page="limit" :total-rows="total"/>
        </b-card>
      </template>
      <b-card v-else>
        <b-card-title>{{ $t('contentShares.errors.no-active-content') }}</b-card-title>
      </b-card> -->

      <!-- Edit Modal -->
      <template v-if="isRecruiter && selectedContentShareID">
        <b-modal
          v-if="selectedContentShares && selectedContentShares.id"
          visible
          size="xl"
          :title="contentShareEditorModalTitle"
          no-close-on-backdrop
          hide-footer
          @hidden="onShareModalClosed"
        >
            <error-block v-if="selectedContentShareErr" class="mb-3" :err="selectedContentShareErr"/>
            <content-share-fetch
              :loading="$apollo.queries.prefetchedContentShare.loading"
              :prefetchError="prefetchError"
              :value="{
                url: prefetchURL || selectedContentShares.url,
                ...(prefetchedContentShare || (({ url, ...r }) => r)(selectedContentShares || {})),
              }"
              @fetchContent="fetchContent($event)"
              @dismissPrefetchError="prefetchError = null"
              @input="updateContentShare"
              @disableSelectedContentShare="disableSelectedContentShare"
              @publishSelectedContentShare="publishSelectedContentShare"
              @deleteSelectedContentShare="deleteSelectedContentShare"
            />
        </b-modal>
        <b-modal
          v-else-if="selectedContentShareID === 'NEW'"
          visible
          size="xl"
          :title="contentShareEditorModalTitle"
          no-close-on-backdrop
          hide-footer
          @hidden="onShareModalClosed"
        >
            <error-block v-if="selectedContentShareErr" class="mb-3" :err="selectedContentShareErr"/>
            <content-share-fetch
              :loading="$apollo.queries.prefetchedContentShare.loading"
              :prefetchError="prefetchError"
              :value="{
                url: prefetchURL,
                ...(prefetchedContentShare || {}),
              }"
              @fetchContent="fetchContent($event)"
              @dismissPrefetchError="prefetchError = null"
              @input="createNewContentShare"
            />
        </b-modal>
      </template>
    </campaign-editor>
  </page>
</template>

<script>
import _chunk from 'lodash/chunk';
import Page from '@/components/campaign-admin/page';
import CampaignEditor from '@/components/campaign-admin/campaign-editor-frame';
import ContentCard from '@/components/content-share/ContentCard';
import ContentShareEditorForm from '@/components/content-share/ContentShareEditorForm';
import ContentShareFetch from '@/components/content-share/ContentShareFetch';
import draggable from 'vuedraggable';
import EntryWhereSomeInput from '@src/components/manage/EntryWhereSomeInput';
import Share from '@/components/Share';
import CampaignAdminContentSharesQuery from '@/graphql/queries/CampaignAdminContentShares.gql';
import PrefetchContentShareQuery from '@/graphql/queries/PrefetchContentShare.gql';
import ContentShareCreateMutation from '@/graphql/mutations/ContentShareCreate.gql';
import ContentShareUpdateMutation from '@/graphql/mutations/ContentShareUpdate.gql';
import UpdateCampaignMutation from '@/graphql/mutations/UpdateCampaign.gql';
import { RichTextContent } from '@/components/RichTextField';
import ErrorBlock from '@/components/misc/ErrorBlock';
import distanceInWords from 'date-fns/distance_in_words';
import { mapRoot } from '@src/mixins/root';
import gql from 'graphql-tag';

const AddContentSharesToJamsMutation = gql`
  mutation AddContentSharesToJams($campaign: CampaignWhereOneInput!, $contentShareIDs: [ID!]) {
    addContentSharesToJams(campaign: $campaign, contentShareIDs: $contentShareIDs)
  }
`;

export default {
  components: {
    Page,
    CampaignEditor,
    ContentCard,
    ContentShareEditorForm,
    ContentShareFetch,
    draggable,
    EntryWhereSomeInput,
    ErrorBlock,
    RichTextContent,
    Share,
  },
  mixins: [
    // enumsMixin,
  ],
  props: {
    campaignID: {
      type: String,
    },
  },
  data: () => ({
    allContentSharesErr: null,
    selectedContentShareID: null,
    selectedContentShares: null,
    selectedContentShareErr: null,
    filterContentSharesPage: 1,
    filterContentSharesLimit: 12,
    filterContentSharesOrder: 'CREATED_DESC',
    prefetchedContentShare: null,
    prefetchURL: null,
    prefetchError: null,
    referralJamsContent: [],
    searchTerm: null,
    showJamContent: false,
    working: {},
    campaign: null,
  }),
  metaInfo() {
    return {
      title: this.$t('contentShares.title'),
    };
  },
  apollo: {
    api: {
      query: CampaignAdminContentSharesQuery,
      variables() {
        const { campaignID } = this;
        return { campaignID };
      },
      update(data) {
        return data;
      },
      result({ loading, data }) {
        if (!loading && data && data.company && data.company.id) {
          // const firstRun = this.campaign === null;
          const { campaign } = data.company;

          this.campaign = campaign && campaign.id ? campaign : null;

          const { contentShares, event } = this.campaign || {};
          this.referralJamsContent = event ? (Array.isArray(event.contentShares) ? event.contentShares : []).map(({ id }) => id) : [];
          console.log('contentShares IS: ', contentShares);
          this.selectedContentShares = Array.isArray(contentShares) ? contentShares : null;

          // const { contentShares } = data.company.campaign.contentShares;
          // this.contentShares = contentShares;
          return campaign;
        }
      },
      manual: true,
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the campaigns' });
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    prefetchedContentShare: {
      query: PrefetchContentShareQuery,
      variables() {
        const { prefetchURL } = this;
        return { url: prefetchURL };
      },
      manual: true,
      result({ data: { company }, loading }) {
        if (!loading) {
          const { contentSharePrefetch } = company || {};
          const { image, ...contentShare } = contentSharePrefetch || {};
          if (!contentShare.title || !contentShare.description) {
            this.prefetchError = 'fetching content was unsuccessful';
          }
          this.prefetchedContentShare = { imageURL: image, ...contentShare };
        }
      },
      error(error) {
        this.prefetchError = error;
      },
      skip() {
        const { isRecruiter, prefetchURL } = this;
        return !isRecruiter || !prefetchURL;
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiter', 'isEnglishLang' ]),
    contentShareEditorModalTitle() {
      const { selectedContentShareID: id } = this;
      return id ? (id === 'NEW' ? 'Create Content' : 'Edit Content') : null;
    },
    filterSelectedContent() {
      if (!this.showJamContent) {
        if (this.searchTerm === null || this.searchTerm === '') {
          return this.selectedContentShares;
        } else {
          const enteredSearchTerm = this.searchTerm.trim().toLowerCase();
          return this.selectedContentShares.filter(content => content.title.trim().toLowerCase().includes(enteredSearchTerm));
        }
      } else {
        if (this.searchTerm === null || this.searchTerm === '') {
          return this.selectedContentShares.filter(content => this.referralJamsContent.includes(content.id));
        } else {
          const enteredSearchTerm = this.searchTerm.trim().toLowerCase();
          return this.selectedContentShares.filter(content => {
            return this.referralJamsContent.includes(content.id) && content.title.trim().toLowerCase().includes(enteredSearchTerm);
          });
        }
      }
    },
    rows() {
      const { edges } = this.contentShareConnections || {};
      if (Array.isArray(edges) && edges.length) {
        return _chunk(edges.map(({ entry }) => entry), 3);
      } else {
        return [];
      }
    },
    page() {
      const { page } = this.contentShareConnections;
      return page || 1;
    },
    limit() {
      const { limit } = this.contentShareConnections;
      return limit || 10;
    },
    total() {
      const { total } = this.contentShareConnections;
      return total || 0;
    },
    totalPages() {
      const { totalPages } = this.contentShareConnections;
      return totalPages || 1;
    },
    totalContentSelected() {
      if (this.selectedContentShares === null) {
        return 0;
      } else {
        return this.selectedContentShares.length;
      }
    }
  },
  methods: {
    saveAndNext() {
      this.saveContent();
      this.$router.push({ name: 'EditCampaignGamification', params: { campaignID: this.campaign.id } });
    },
    truncateContentTitle(contentTitle) {
      if (contentTitle.length < 40) {
        return contentTitle;
      } else {
        return contentTitle.substring(0, 40).concat('...');
      }
    },
    toggleJamContent() {
      this.showJamContent = !this.showJamContent;
    },
    async saveContent() {
      try {
        const { campaignID, selectedContentShares, referralJamsContent } = this;
        console.log(this.selectedContentShares);
        await this.$apollo.mutate({
          mutation: UpdateCampaignMutation,
          variables: {
            where: { id: campaignID },
            update: {
              contentShares: Array.isArray(selectedContentShares) && selectedContentShares.length ? { id_in: selectedContentShares.map(({ id }) => id) }
                : null
            },
          },
        });

        if (Array.isArray(referralJamsContent) && referralJamsContent.length) {
          console.log('IM RUNNING');
          await this.$apollo.mutate({
            mutation: AddContentSharesToJamsMutation,
            variables: {
              campaign: { id: campaignID },
              contentShareIDs: referralJamsContent
            },
          });
        }

        this.$notification({ message: 'Successfully saved content to campaign', variant: 'success' });
      } catch (err) {
        this.$notifyErr(err, { prepend: 'Failed to save content on campaign' });
      }
    },
    bookmarkContent(contentID) {
      if (this.bookmarkContent.length === 0 || this.referralJamsContent.includes(contentID) === false) {
        this.referralJamsContent.push(contentID);
      } else {
        if (this.referralJamsContent.includes(contentID)) {
          this.referralJamsContent = this.referralJamsContent.filter(content => content !== contentID);
        }
      }
    },
    trackShareEvent({ id: contentShareID }, { channel }) {
      return this.$root.captureLog({
        eventName: 'CONTENT_SHARED',
        contentShare: { id: contentShareID },
        user: { self: true },
        data: channel ? [ { key: 'channel', value: channel } ] : null,
      });
    },
    onShareModalClosed() {
      this.prefetchURL = null;
      this.prefetchedContentShare = null;
      this.selectedContentShareID = null;
      this.selectedContentShares = null;
      this.selectedContentShareErr = null;
    },
    timeAgo(createdAt) {
      return distanceInWords(new Date(), createdAt, { addSuffix: true });
    },
    async createNewContentShare(create) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: ContentShareCreateMutation,
          variables: { create },
        });

        if (data && data.createContentShare && data.createContentShare.id) {
          const { title } = data.createContentShare;
          this.$notification({
            title: 'Content created',
            message: `Content with title '${title}' is created successfully`,
            variant: 'success',
          });
        } else {
          throw new Error('Failed to create content');
        }

        // await this.$apollo.queries.contentShareConnections.refetch();
        // await this.onShareModalClosed();
      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
    async updateContentShare(update) {
      const { selectedContentShareID: contentShareID } = this;
      if (!contentShareID) {
        return this.$notifyErr(new Error('Missing selectedContentShareID'));
      }

      try {
        const { data } = await this.$apollo.mutate({
          mutation: ContentShareUpdateMutation,
          variables: { contentShareID, update },
        });

        if (data && data.updateContentShare && data.updateContentShare.id) {
          const { title } = data.updateContentShare;
          this.$notification({
            title: 'Content updated',
            message: `Content with title '${title}' is updated successfully`,
            variant: 'success',
          });
        } else {
          throw new Error('Failed to update content');
        }

        await this.$apollo.queries.contentShareConnections.refetch();
        await this.onShareModalClosed();
      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
    async disableSelectedContentShare() {
      const { selectedContentShareID: contentShareID } = this;
      if (!contentShareID) {
        return this.$notifyErr(new Error('Missing selectedContentShareID'));
      }

      try {
        const { data } = await this.$apollo.mutate({
          mutation: ContentShareUpdateMutation,
          variables: { contentShareID, update: { status: 'INACTIVE' } },
        });

        if (data && data.updateContentShare && data.updateContentShare.id) {
          const { title } = data.updateContentShare;
          this.$notification({
            title: 'Content is archived',
            message: `Content with title '${title}' is archived`,
            variant: 'success',
          });
        } else {
          throw new Error('Failed to archive content');
        }

        await this.$apollo.queries.contentShareConnections.refetch();
        await this.onShareModalClosed();
      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
    async publishSelectedContentShare() {
      const { selectedContentShareID: contentShareID } = this;
      if (!contentShareID) {
        return this.$notifyErr(new Error('Missing selectedContentShareID'));
      }

      try {
        const { data } = await this.$apollo.mutate({
          mutation: ContentShareUpdateMutation,
          variables: { contentShareID, update: { status: 'ACTIVE' } },
        });

        if (data && data.updateContentShare && data.updateContentShare.id) {
          const { title } = data.updateContentShare;
          this.$notification({
            title: 'Content is published',
            message: `Content with title '${title}' is published`,
            variant: 'success',
          });
        } else {
          throw new Error('Failed to publish content');
        }

        await this.$apollo.queries.contentShareConnections.refetch();
        await this.onShareModalClosed();
      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
    async deleteSelectedContentShare() {
      const { selectedContentShareID: contentShareID } = this;
      if (!contentShareID) {
        return this.$notifyErr(new Error('Missing selectedContentShareID'));
      }

      try {
        await this.$apollo.mutate({
          mutation: ContentShareUpdateMutation,
          variables: { contentShareID, update: { status: 'DELETED' } },
        });

        this.$notification({
          title: 'Content is deleted',
          message: 'Content is successfully deleted',
          variant: 'success',
        });

        await this.$apollo.queries.contentShareConnections.refetch();
        await this.onShareModalClosed();
      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
    async fetchContent(url) {
      this.prefetchURL = null;
      if (url === this.prefetchURL) {
        await this.$apollo.queries.prefetchedContentShare.refetch();
        return;
      }
      this.prefetchURL = url;
    }
  },
  watch: {
    selectedContentShares() {
      console.log('WATCHER: ', this.selectedContentShares);
    }
  }
};
</script>

<style lang="scss" scoped>
  .no-content-box {
    padding: 50px 15px;
    text-align: center;
  }
  p {
    font-size: 1.05rem;
  }
  .draggable-icon {
    font-size: 1.3rem;
  }
  .bg-bar-color {
    background-color: #dee2e6;
  }
  .inactiveButton {
    color: #001DC0;
    text-decoration: underline;
  }
  .activeButton {
    color: white;
    background-color: #001DC0;
  }
  .activeButton:hover {
    background-color: red;
    color: white;
  }
  .inactiveButton:hover {
    color: white;
    background-color: #001DC0;
  }
  .hamburger-icon:hover {
    cursor: move;
  }
  .hidden {
    visibility: hidden;
  }
  .link-styling {
    text-decoration: underline;
    cursor: pointer;
  }
  .preview-image {
    width: 25px;
    height: 25px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/campaign-admin/Content.vue